module.exports = __webpack_public_path__ + "img/sprinkle-24.3c60dc7f.webp";